module.exports = "<p>\n  not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.html
// module id = ./src/app/components/not-found/not-found.component.html
// module chunks = main